import _ from "lodash";
import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import {erNill} from "felles/stoettefunk/nillsjekk";

//ng2 ekvivalent: lederplan-klient/src/scripts/felles-ng2/støttefunksjoner/mimetyper.ts og lederplan-klient/src/scripts/felles-ng2/støttefunksjoner/filer.ts
export class Filer {

    static regNavn = "Filer";

    private static filendelse = /.*\.(\w+)$/;
    private static norskeErstatninger = {'å':'aa', 'Å':'AA', 'ø':'oe', 'Ø':'OE', 'æ':'ae', 'Æ':'AE'}

    static forInjisering() {
        return [
            Konfigurasjon.regNavn,
            Filer
        ]
    }

    constructor(private konfigurasjon: Konfigurasjon) {
    }

    //offentlige metoder

    /** funnet på internett ett sted :) */
    filStørreseILesbarForm(size:number) {
        let sizes = [' Bytes', ' KB', ' MB', ' GB',
            ' TB', ' PB', ' EB', ' ZB', ' YB'];

        for (let i = 1; i < sizes.length; i++) {
            if (size < Math.pow(1024, i))
                return (Math.round((size / Math.pow(
                  1024, i - 1)) * 100) / 100) + sizes[i - 1];
        }
        return size;
    }

    /** maks filstørresle i menneskelig lesbar form, dvs 150 MB*/
    maxFilstørrelseILesbarForm(){
        return this.filStørreseILesbarForm(this.konfigurasjon.maksFilstørrelse)
    }

    maksZipImportFilStørrelseILesbarForm(){
        return this.filStørreseILesbarForm(this.konfigurasjon.maksFilstørrelseArkivImport);
    }

    filerSomErForStore(filer: File[]): File[] {
        return filer.filter(fil => this.filErForStor(fil));
    }

    tommeFiler(filer: File[]): File[] {
        return filer.filter(fil => fil == null || fil.size <= 0)
    }


    filendelseFraFile(fil: File): string {
        var endelse = fil.name.match(Filer.filendelse);
        return endelse ? _.toLower(endelse[1]) : "";
    }

    filendelse(filnavn: string): string {
        var endelse = filnavn.match(Filer.filendelse);
        return endelse ? _.toLower(endelse[1]) : "";
    }

    /** Returnerer streng som består av alle tillatte mimetyper og alle tillatte filendelser, kommaseparert.
     * egnet for bruk i <input type=file accept=[tillatteFiltyper]> */
    tillatteMimetyperOgFilendelser(): string {
        return _.union(
            this.tillatteMimetyper(),
            this.tillatteFilendelser().map(endelse => '.' + endelse)
        ).join(",");
    }

    tillatteFilendelser(): string[] {
        return _(tillatteFiltyper).map(type => type.filendelse).flatten().value();
    }

    tillatteMimetyper(): string[] {
        return tillatteFiltyper.map(type => type.mimetype);
    }

    tillatteAppleUtier(): string[] {
        return _(tillatteFiltyper).map(type => type.appleUti).flatten().value();
    }

    erTillattFiltype(filnavn: string) {
        return _.includes(this.tillatteFilendelser(), this.filendelse(filnavn));
    }

    filErIkkeForStor(fil: File): boolean {
        return !this.filErForStor(fil);
    }

    filErForStor(fil: File): boolean {
        if (_.isNil(fil)) return false;
        if (fil.size > this.konfigurasjon.maksFilstørrelse) {
            return true
        }
        return false;
    }

    filZipImportErForStor(fil: File): boolean {
        if (erNill(fil)) return false;
        return fil.size > this.konfigurasjon.maksFilstørrelseArkivImport;
    }

    finnMimeinfoBasertPåMimetype(mimetype: string): Mimeinfo {
        const mimeinfo = Filer.mimetyper[_.findKey(Filer.mimetyper, {mimetype: mimetype})];
        if (!_.isNil(mimeinfo)) return mimeinfo;
        return {
            mimetype: mimetype,
            appleUti: [],
            filendelse: [],
            visningsnavn: mimetype,
            ikon: 'lederplan-ikon-dokument'
        }
    }

    finnMimeinfoBasertPåFilendelse(fil: File): Mimeinfo {
        const filendelse = this.filendelseFraFile(fil);
        const mimeinfo = _(Filer.mimetyper).values().find(type => _.includes(type.filendelse, filendelse))
        return mimeinfo ? mimeinfo : this.fallbackMimetype;
    }

    finnMimetypeBasertPåFilendelse(fil: File): string {
        const filendelse = this.filendelseFraFile(fil);
        const mimeinfo = _(Filer.mimetyper).values().find(type => _.includes(type.filendelse, filendelse))
        return mimeinfo ? mimeinfo.mimetype : undefined;
    }

    static somSikkertFilnavn(navn:string){
        if (_.isEmpty(navn)) return navn;
        //håndtere norske tegn spesielt
        _.keys(Filer.norskeErstatninger).forEach(tegn => navn = navn.replace(tegn, Filer.norskeErstatninger[tegn]))
        return navn.replace(/[^\w| |\.|_|-]+/g, '_')
    }

    /**
     * Info mimetyper - må holdes i synk med no.systemfabrikken.lederplan.tjenester.dokumenter.TillateMimetyper,
     * ref no.systemfabrikken.lederplan.domene.dokument.OpplastetDokumentVersjon.OpplastetDokumentVersjonBygger.valider
     * Se http://filext.com/faq/office_mime_types.php for office typer
     * Se https://developer.apple.com/library/archive/documentation/Miscellaneous/Reference/UTIRef/Articles/System-DeclaredUniformTypeIdentifiers.html for UTI-typer
     */
      //@todo migrer til mimetyper.ts
    static mimetyper: { [type: string]: Mimeinfo } = {
        pdf: {
            mimetype: 'application/pdf',
            appleUti: ['com.adobe.pdf'],
            filendelse: ['pdf'],
            visningsnavn: 'PDF',
            ikon: 'lederplan-ikon-pdf'
        },

        txt: {
            mimetype: 'text/plain',
            appleUti: ['public.text'],
            filendelse: ['txt'],
            visningsnavn: 'Text',
            ikon: 'lederplan-ikon-dokument'
        },

        rtf: {
            mimetype: 'application/rtf',
            appleUti: ['public.text'],
            filendelse: ['rtf'],
            visningsnavn: 'Word',
            ikon: 'lederplan-ikon-word'
        },

        sdo: {
            mimetype: 'application/x-seid-sdo',
            appleUti: ['public.xml'],
            filendelse: ['sdo'],
            visningsnavn: 'SDO',
            ikon: 'lederplan-ikon-dokument'
        },

        png: {
            mimetype: 'image/png',
            appleUti: ['public.image'],
            filendelse: ['png'],
            visningsnavn: 'png',
            ikon: 'lederplan-ikon-dokument'
        },

        tiff: {
            mimetype: 'image/tiff',
            appleUti: ['public.image'],
            filendelse: ['tiff'],
            visningsnavn: 'tiff',
            ikon: 'lederplan-ikon-dokument'
        },

        gif: {
            mimetype: 'image/gif',
            appleUti: ['public.image'],
            filendelse: ['gif'],
            visningsnavn: 'gif',
            ikon: 'lederplan-ikon-dokument'
        },

        jpeg: {
            mimetype: 'image/jpeg',
            appleUti: ['public.image'],
            filendelse: ['jpg', 'jpeg'],
            visningsnavn: 'jpg',
            ikon: 'lederplan-ikon-dokument'
        },

        //ms excel
        xls: {
            mimetype: 'application/vnd.ms-excel',
            appleUti: ['com.microsoft.excel.xls'],
            filendelse: ['xls'],
            visningsnavn: 'Excel',
            ikon: 'lederplan-ikon-excel'
        },
        xlsx: {
            mimetype: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            appleUti: ['org.openxmlformats.spreadsheetml.sheet'],
            filendelse: ['xlsx'],
            visningsnavn: 'Excel',
            ikon: 'lederplan-ikon-excel'
        },

        //ms powerpoint
        ppt: {
            mimetype: 'application/vnd.ms-powerpoint',
            appleUti: ['com.microsoft.powerpoint.ppt'],
            filendelse: ['ppt'],
            visningsnavn: 'PPT',
            ikon: 'lederplan-ikon-ppt'
        },
        pptx: {
            mimetype: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            appleUti: ['org.openxmlformats.presentationml.presentation'],
            filendelse: ['pptx'],
            visningsnavn: 'PPT',
            ikon: 'lederplan-ikon-ppt'
        },
        ppsx: {
            mimetype: 'application/application/vnd.openxmlformats-officedocument.presentationml.slideshow',
            appleUti: ['org.openxmlformats.presentationml.slideshow'],
            filendelse: ['ppsx'],
            visningsnavn: 'PPT',
            ikon: 'lederplan-ikon-ppt'
        },

        //ms word
        doc: {
            mimetype: 'application/msword',
            appleUti: ['com.microsoft.word.doc'],
            filendelse: ['doc'],
            visningsnavn: 'Word',
            ikon: 'lederplan-ikon-word'
        },
        docx: {
            mimetype: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            appleUti: ['com.microsoft.word.wordml', 'org.openxmlformats.wordprocessingml.document'],
            filendelse: ['docx'],
            visningsnavn: 'Word',
            ikon: 'lederplan-ikon-word'
        },
        //openoffice mimetyper, stiler disse som office-dokumenter
        odt: {
            mimetype: 'application/vnd.oasis.opendocument.text',
            appleUti: ['com.microsoft.word.wordml', 'org.openxmlformats.wordprocessingml.document'],
            filendelse: ['odt'],
            visningsnavn: 'Word',
            ikon: 'lederplan-ikon-word'
        },
        ods: {
            mimetype: 'application/vnd.oasis.opendocument.spreadsheet',
            appleUti: ['org.openxmlformats.spreadsheetml.sheet'],
            filendelse: ['ods'],
            visningsnavn: 'Excel',
            ikon: 'lederplan-ikon-excel'
        },
        odp: {
            mimetype: 'application/vnd.oasis.opendocument.presentation',
            appleUti: ['org.openxmlformats.presentationml.presentation'],
            filendelse: ['odp'],
            visningsnavn: 'PPT',
            ikon: 'lederplan-ikon-ppt'
        },
        zip: {
            mimetype: 'application/zip',
            appleUti: ['com.pkware.zip-archive'],
            filendelse: ['zip'],
            visningsnavn: 'ZIP',
            ikon: 'lederplan-ikon-zip'
        },
    };

    fallbackMimetype: Mimeinfo = {
        mimetype: 'application/octet-stream',
        appleUti: [],
        filendelse: [],
        visningsnavn: 'Ukjent',
        ikon: 'lederplan-ikon-dokument'
    };
}

export interface Mimeinfo {
    mimetype: string;
    appleUti: string[];
    filendelse: string[];
    visningsnavn: string;
    ikon: string;
}

//todo kai lastes fra konfig på serversiden
//@todo bruker enum eksponert via generert ressursklient?
/** mimetyper vi tillater at bruker laster opp, må holdes i synk med no.systemfabrikken.lederplan.tjenester.dokumenter.TillateMimetyper */
export const tillatteFiltyper = [
    Filer.mimetyper.pdf,
    Filer.mimetyper.txt,
    Filer.mimetyper.rtf,
    Filer.mimetyper.sdo,
    Filer.mimetyper.png,
    Filer.mimetyper.gif,
    Filer.mimetyper.tiff,
    Filer.mimetyper.jpeg,
    Filer.mimetyper.docx,
    Filer.mimetyper.doc,
    Filer.mimetyper.xlsx,
    Filer.mimetyper.xls,
    Filer.mimetyper.pptx,
    Filer.mimetyper.ppt,
    Filer.mimetyper.odp,
    Filer.mimetyper.ods,
    Filer.mimetyper.odt,
    Filer.mimetyper.zip
]
